import * as templateLists from "./template-lists";
import * as selectTemplate from "./select-template";
import * as editor from "./editor";

export const reducer = () => ({
  [templateLists.MODULE]: templateLists.reducer,
  [selectTemplate.MODULE]: selectTemplate.reducer,
  [editor.MODULE]: editor.reducer,
});

export default {};
